module.exports = __webpack_public_path__ + "img/bj22.14593430.png";